import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { FiltersScrollableWrapper } from 'src/domains/layouts/webview/components/filters/FiltersScrollableWrapper';
import { FiltersNewView } from 'src/domains/layouts/webview/components/filters/Filters';
import { MarketFiltersState } from './MarketFilters.state';
import { MarketFiltersWrapper } from 'src/domains/sportsbook/webview/components/marketFilters/MarketFilters.style';
import { MarketFiltersForSportState } from 'src/domains/sportsbook/state/marketFiltersState/MarketFiltersForSportState';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropsType {
    marketFiltersForSport: MarketFiltersForSportState;
}

export const MarketFilters = observer('MarketFilters', ({ marketFiltersForSport }: PropsType) => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const filtersState = new MarketFiltersState(marketFiltersForSport);
    const { filters, activeFilter } = filtersState;

    return (
        <MarketFiltersWrapper variant={configState.componentVariants.sportsbookVariant}>
            <FiltersScrollableWrapper>
                <FiltersNewView
                    select={activeFilter}
                    skin={configState.filtersVersion.football}
                    filters={filters}
                />
            </FiltersScrollableWrapper>
        </MarketFiltersWrapper>
    );
});
